import { WorkModel } from '@Entities/work/work'
import { OverclaimViewModel } from '@Entities/overclaim/overclaim-view'
import { OpenFeature } from '@openfeature/react-sdk'
import dayjs from 'dayjs'

const isOverclaimAllowed = (workDraft: OverclaimViewModel | WorkModel | undefined) => {
    if (workDraft?.createdDate && !OpenFeature.getClient().getBooleanValue('unrestricted-overclaims', false)) {
        const dateThreeMonthsAgo = dayjs(new Date()).subtract(90, 'days').utc()
        const registrationDate = dayjs(workDraft?.createdDate).utc()
        return registrationDate.isAfter(dateThreeMonthsAgo)
    }
    return !isWorkOverclaimView(workDraft)
}

const isWorkOverclaimView = (workDraft: OverclaimViewModel | WorkModel | undefined): workDraft is OverclaimViewModel =>
    !!(workDraft && (workDraft as OverclaimViewModel).workType === 'overclaim')

export { isOverclaimAllowed }
